import { IEvent } from '@interfaces/event';
import ParticipantScopes from '@constants/scopes';

export const isBroadcastEnabled = (permission: ParticipantScopes[] = []) =>
  permission?.includes(ParticipantScopes.HubBroadcastEnabled);

export const isPrivateChatEnabled = ({
  currentEvent,
  userPermissions,
}: {
  userPermissions?: ParticipantScopes[];
  currentEvent?: IEvent;
}) => {
  const isOfficeHours =
    currentEvent?.eventTags &&
    currentEvent?.eventTags.indexOf('OfficeHours') > -1;

  const isPrivateChatEnabled = userPermissions?.includes(
    ParticipantScopes.HubPrivateChat,
  );

  return !isOfficeHours || (isOfficeHours && isPrivateChatEnabled);
};
